<template>
	<ListItem class="c-list-item-project" v-bind="$props">
		<div
			v-if="
				details &&
				((details.managers && details.managers.value) ||
					(details.participants && details.participants.value) ||
					(details.financedBy && details.financedBy.value))
			"
			class="
				w-full
				flex
				<768:flex-col
				gap-x-sm/h gap-y-xs/v
				mt-md/v
				<768:mt-3xs/v
				>=768:pr-sm/h
			"
		>
			<div
				v-if="details && details.managers && details.managers.value"
				class="
					flex flex-col
					<768:w-full
					w-fit
					>=768:max-w-330
					flex-grow-0
					pr-5xs/h
				"
			>
				<div class="font-medium text-body-sm">
					{{ details.managers.label }}
				</div>
				<div class="flex flex-wrap">
					<span
						v-for="(value, index) in details.managers.value"
						:key="value.id"
						class="pt-4 text-label leading-1.2"
					>
						<NuxtLinkExt
							:is="value.url ? 'NuxtLinkExt' : 'span'"
							:to="value.url"
							class="text-label leading-1.2"
							:class="{ 'text-red underline': value.url }"
							v-text="
								value.name +
								(details.managers.value.length > 1 &&
								index < details.managers.value.length - 2
									? ','
									: '')
							"
						/>
						<template
							v-if="index === details.managers.value.length - 2"
						>
							&
						</template>
						<template
							v-if="index !== details.managers.value.length - 1"
						>
							&nbsp;
						</template>
					</span>
				</div>
			</div>
			<div
				v-if="
					details &&
					details.participants &&
					details.participants.value
				"
				class="
					flex flex-col
					<768:w-full
					w-fit
					>=768:max-w-330
					flex-grow-0
					pr-5xs/h
				"
			>
				<div class="font-medium text-body-sm">
					{{ details.participants.label }}
				</div>
				<div class="flex flex-wrap">
					<span
						v-for="(value, index) in details.participants.value"
						:key="value.id"
						class="pt-4 text-label leading-1.2"
					>
						<NuxtLinkExt
							:is="value.url ? 'NuxtLinkExt' : 'span'"
							:to="value.url"
							class="text-label leading-1.2"
							:class="{ 'text-red underline': value.url }"
							v-text="
								value.name +
								(details.participants.value.length > 1 &&
								index < details.participants.value.length - 2
									? ','
									: '')
							"
						/>
						<template
							v-if="
								index === details.participants.value.length - 2
							"
						>
							&
						</template>
						<template
							v-if="
								index !== details.participants.value.length - 1
							"
						>
							&nbsp;
						</template>
					</span>
				</div>
			</div>
			<div
				v-if="details && details.financedBy && details.financedBy.value"
				class="
					flex flex-col
					<768:w-full
					w-fit
					>=768:max-w-330
					flex-grow-0
				"
			>
				<div class="font-medium text-body-sm">
					{{ details.financedBy.label }}
				</div>
				<div class="pt-4 text-label font-light">
					{{ details.financedBy.value }}
				</div>
			</div>
		</div>
	</ListItem>
</template>

<script>
import ListItem from '~/components/main/ListItem';

export default {
	name: 'ListItemProject',

	components: {
		ListItem,
	},

	props: {
		...ListItem.props,

		// Explicitly used props
		theme: {
			type: String,
			default: 'red',
		},

		details: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {},
};
</script>

<style lang="postcss">
.c-list-item-project__image {
	overflow: hidden;
	aspect-ratio: 1;

	& .c-list-item-project__photo {
		@apply w-full h-full rounded-full overflow-hidden;
		background: rgba(0, 0, 0, 0.04);
		clip-path: circle(50% at 50% 50%);

		& > *,
		& picture {
			@apply w-full h-full rounded-full overflow-hidden;
		}
		& picture {
			transition: scale 0.2s ease-in-out, clip-path 0.2s ease-in-out;
			clip-path: circle(50% at 50% 50%);
		}
	}
}

.c-list-item-project__image-form {
	@apply relative isolate w-140 h-140;
	aspect-ratio: 1;
}

.c-list-item-project:hover .c-list-item-project__image picture,
.c-list-item-project:focus-within .c-list-item-project__image picture {
	scale: 1.05;
	clip-path: circle(47.5% at 50% 50%);
}

.c-list-item-project__areas {
	margin-inline: -4px;
	width: calc(100% + 8px);
}
.c-list-item-project__areas > :last-child {
	margin-right: 42px;
}
</style>
